/**
 * This Software is the property of dotfly and is protected
 * by copyright law - it is NOT Freeware.
 *
 * Any unauthorized use of this software without a valid license key
 * is a violation of the license agreement and will be prosecuted by
 * civil and criminal law.
 *
 * @category   Mobile Menu
 * @author     Anna Morawe <anna.morawe@dotfly.de>
 * @license    http://www.dotfly.de Commercial
 * @link       http://www.dotfly.de
 */

/* eslint-disable */

var oMobileMenu = document.getElementsByClassName('js-navbar');

for (var i = 0; i < oMobileMenu.length; i++) {

    document.addEventListener(
        "DOMContentLoaded", () => {
            new Mmenu( "#menu", {
                "offCanvas": {
                    "position": "right-front"
                },
                "theme": "light",
                "navbars": [
                    {
                        "position": "right-front",
                        "content": [
                            "close",
                            "prev",
                            "title"
                        ]
                    }
                ]
            });
        }
    );

}
/* eslint-enable */
